import { useEffect } from 'react';

/** The JS version this tab last reloaded onto. Session storage outlives the reload, per tab. */
const RELOADED_ONTO_KEY = 'appVersionGate.reloadedOnto';

/**
 * While mounted, reloads the page onto the app's latest web deploy, `jsVersion`, once it is out
 * (`null` until then, pushed by the `checkAppVersion` subscription). At most once per deploy: a
 * reload can still load a build that is still blocked (one CI didn't deploy), and would keep
 * loading it, so the tab waits for the next deploy instead.
 */
export const useReloadOntoLatestDeploy = (jsVersion: number | null) => {
  useEffect(() => {
    if (jsVersion === null || sessionStorage.getItem(RELOADED_ONTO_KEY) === String(jsVersion)) {
      return;
    }
    sessionStorage.setItem(RELOADED_ONTO_KEY, String(jsVersion));
    window.location.reload();
  }, [jsVersion]);
};
